var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-row', {
    staticClass: "ma-n12px ma-md-n26px"
  }, _vm._l(_vm.giftcards, function (giftcard) {
    return _c('v-col', {
      key: giftcard === null || giftcard === void 0 ? void 0 : giftcard._id,
      staticClass: "pa-12px pa-md-26px",
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-img', {
      staticClass: "border",
      attrs: {
        "src": "https://daehanbooksgiftcard.com/".concat(giftcard === null || giftcard === void 0 ? void 0 : giftcard.thumb),
        "max-width": "500",
        "aspect-ratio": 500 / 500,
        "contain": ""
      }
    }, [_vm.getCommission(giftcard) ? [_c('v-chip', {
      staticClass: "commission-chip",
      attrs: {
        "color": "red",
        "text-color": "white",
        "small": ""
      }
    }, [_vm._v(_vm._s("".concat(_vm.getCommission(giftcard), "% \uC218\uC218\uB8CC")))])] : _vm._e()], 2), _c('div', {
      staticClass: "text-center py-12px py-md-16px"
    }, [_c('div', {
      staticClass: "font-size-14 font-size-md-16 text-truncate font-weight-bold"
    }, [_vm._v(_vm._s(giftcard === null || giftcard === void 0 ? void 0 : giftcard.name))]), _c('div', {
      staticClass: "font-size-16 font-size-md-18 mt-6px"
    }, [_c('b', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(_vm.getSalePrice(giftcard)))]), _vm._v(" 원 ")])]), _c('div', [_c('v-btn', {
      staticClass: "font-size-16 font-size-md-18",
      attrs: {
        "large": "",
        "block": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.order(giftcard);
        }
      }
    }, [_vm._v("구매하기")])], 1)], 1);
  }), 1), _c('giftcard-topping-popup', {
    ref: "giftcardToppingPopup"
  }), _c('giftcard-ats-popup', {
    ref: "giftcardAtsPopup"
  }), _c('giftcard-dialog', {
    ref: "giftcardDialog"
  }), _c('login-dialog', {
    ref: "loginDialog"
  }), _c('kcb-cert', {
    ref: "kcbCert"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }